import { Check, Phone } from "lucide-react";

const TIERS = [
  {
    key: "toilet",
    eyebrow: "Toiletrenovatie",
    price: "€1200",
    duration: "Gemiddeld 3 dagen",
    accent: "orange",
    included: [
      "Sloop & afvoer oude toilet",
      "Aanpassen water- en afvoerleidingen",
      "Plaatsen Geberit inbouwframe",
      "Tegelwerk wand & vloer",
      "Plaatsen hangtoilet & bedieningsplaat",
      "Afkitten en complete oplevering",
    ],
    cta: "Bel voor toilet-offerte",
  },
  {
    key: "badkamer",
    eyebrow: "Badkamerrenovatie",
    price: "€6000",
    duration: "Gemiddeld 1–2 weken",
    accent: "blue",
    included: [
      "Sloop oude badkamer & afvoer",
      "Vernieuwen leidingwerk en afvoer",
      "Plaatsen douche, bad of inloopdouche",
      "Wastafel met meubel & spiegel",
      "Volledig tegelwerk wand & vloer",
      "Sanitair plaatsen & complete oplevering",
    ],
    cta: "Bel voor badkamer-offerte",
  },
];

export default function Pricing() {
  return (
    <section
      id="prijzen"
      className="bg-white py-20 lg:py-28"
      data-testid="pricing-section"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center">
          <p className="text-sm font-bold uppercase tracking-[0.2em] text-blue-700">
            Eerlijke vaste prijs
          </p>
          <h2 className="font-display font-bold mt-3 text-4xl sm:text-5xl tracking-tight text-slate-900">
            Twee diensten,{" "}
            <span className="text-orange-500">één belofte</span> — geen verrassingen.
          </h2>
          <p className="mt-5 text-lg text-slate-600">
            Of je nu alleen het toilet wil aanpakken of de hele badkamer:
            jij krijgt een vaste prijs na een gratis inmeting bij jou thuis.
          </p>
        </div>

        <div className="mt-14 grid md:grid-cols-2 gap-6">
          {TIERS.map((tier) => {
            const isBlue = tier.accent === "blue";
            return (
              <div
                key={tier.key}
                className="relative bg-white border-2 border-slate-900 rounded-3xl p-2 shadow-2xl flex flex-col"
                data-testid={`pricing-card-${tier.key}`}
              >
                <div
                  className={`rounded-t-2xl border-t-8 ${
                    isBlue ? "border-blue-700" : "border-orange-500"
                  }`}
                />
                <div className="px-6 sm:px-10 py-10 flex-1 flex flex-col">
                  <div
                    className={`text-xs font-bold uppercase tracking-widest ${
                      isBlue ? "text-blue-700" : "text-orange-500"
                    }`}
                  >
                    {tier.eyebrow}
                  </div>
                  <div className="mt-3">
                    <div className="text-xs font-bold uppercase tracking-widest text-slate-500">
                      Vanaf
                    </div>
                    <div className="font-display font-bold text-6xl sm:text-7xl text-slate-900 leading-none mt-1">
                      {tier.price}
                    </div>
                  </div>
                  <p className="mt-3 text-sm text-slate-500" data-testid={`pricing-duration-${tier.key}`}>
                    {tier.duration} · incl. arbeid en materialen
                  </p>

                  <ul className="mt-8 space-y-3 text-left flex-1">
                    {tier.included.map((item, i) => (
                      <li
                        key={item}
                        className="flex items-start gap-3 text-slate-800"
                        data-testid={`pricing-${tier.key}-item-${i}`}
                      >
                        <span
                          className={`mt-0.5 flex-shrink-0 w-6 h-6 rounded-full text-white flex items-center justify-center ${
                            isBlue ? "bg-blue-700" : "bg-orange-500"
                          }`}
                        >
                          <Check className="w-3.5 h-3.5" strokeWidth={3} />
                        </span>
                        <span className="font-medium">{item}</span>
                      </li>
                    ))}
                  </ul>

                  <a
                    href="tel:+31615460576"
                    className={`mt-10 inline-flex items-center justify-center gap-2 h-12 px-7 rounded-full font-semibold transition-colors text-white ${
                      isBlue
                        ? "bg-blue-700 hover:bg-blue-800"
                        : "bg-orange-500 hover:bg-orange-600"
                    }`}
                    data-testid={`pricing-cta-${tier.key}`}
                  >
                    <Phone className="w-4 h-4" />
                    {tier.cta}
                  </a>
                </div>
              </div>
            );
          })}
        </div>

        <p className="mt-8 text-sm text-slate-500 text-center max-w-2xl mx-auto">
          Eindprijs op basis van gratis inmeting en jouw materiaalkeuze. Geen
          verborgen kosten — meerwerk altijd vooraf in overleg.
        </p>
      </div>
    </section>
  );
}
